// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { ProbesGetHealthzHeadResponse, ProbesGetHealthzGetResponse, SnapshotExportResponse, SnapshotImportData, SnapshotImportResponse, SnapshotOverrideNowData, SnapshotOverrideNowResponse, SnapshotAdvanceData, SnapshotAdvanceResponse, TurnsAssignmentCandidatesData, TurnsAssignmentCandidatesResponse, TurnsGetIssuesData, TurnsGetIssuesResponse, TurnsTurnsOpenForExperiencesData, TurnsTurnsOpenForExperiencesResponse, TurnsEnableData, TurnsEnableResponse, TurnsAssignData, TurnsAssignResponse, TurnsRevertData, TurnsRevertResponse, TurnsSetRequiredParticipantsData, TurnsSetRequiredParticipantsResponse, TurnsCancelData, TurnsCancelResponse, TurnsGetOtherTeamLeadersData, TurnsGetOtherTeamLeadersResponse, TurnsGetPrecedingAndFollowingTeamsData, TurnsGetPrecedingAndFollowingTeamsResponse, TurnsGetData, TurnsGetResponse, TurnsGet2Data, TurnsGet2Response, TurnReportsCreateTurnReportData, TurnReportsCreateTurnReportResponse, TurnReportsGetData, TurnReportsGetResponse, TurnReportsPutData, TurnReportsPutResponse, TurnReportsGetMissingReportsData, TurnReportsGetMissingReportsResponse, TurnReportsGet2Data, TurnReportsGet2Response, SubscriptionsGetNotificationTypesResponse, SubscriptionsGetSubscriptionsData, SubscriptionsGetSubscriptionsResponse, SubscriptionsUpdateSubscriptionsData, SubscriptionsUpdateSubscriptionsResponse, SubscriptionsGetSubscriptionData, SubscriptionsGetSubscriptionResponse, SubscriptionsUpdateSubscriptionData, SubscriptionsUpdateSubscriptionResponse, ShiftsGetShiftsWithoutTeamLeaderResponse, ShiftsGetShiftsForCalendarWeekData, ShiftsGetShiftsForCalendarWeekResponse, ShiftsGetShiftsForDateData, ShiftsGetShiftsForDateResponse, ShiftsGetApplicationEventsData, ShiftsGetApplicationEventsResponse, ShiftsReleaseShiftData, ShiftsReleaseShiftResponse, ShiftsUnreleaseShiftData, ShiftsUnreleaseShiftResponse, ShiftsFreezeShiftData, ShiftsFreezeShiftResponse, ShiftsFreezeShiftsData, ShiftsFreezeShiftsResponse, ShiftsThawShiftData, ShiftsThawShiftResponse, ShiftsCommitShiftData, ShiftsCommitShiftResponse, ShiftsGetIssuesData, ShiftsGetIssuesResponse, ShiftsGetIssuesAllData, ShiftsGetIssuesAllResponse, ShiftsFinalizeShiftData, ShiftsFinalizeShiftResponse, ShiftsCancelData, ShiftsCancelResponse, ShiftsScaffoldData, ShiftsScaffoldResponse, ShiftsPostData, ShiftsPostResponse, ShiftsGetData, ShiftsGetResponse, ShiftsPutData, ShiftsPutResponse, ShiftsDeleteData, ShiftsDeleteResponse, ShiftsGet2Data, ShiftsGet2Response, ShiftApplicationsApplyForShiftData, ShiftApplicationsApplyForShiftResponse, ShiftApplicationsGetData, ShiftApplicationsGetResponse, ShiftApplicationsRevokeShiftApplicationData, ShiftApplicationsRevokeShiftApplicationResponse, ShiftApplicationsRevokeShiftApplicationTheWholeSeriesData, ShiftApplicationsRevokeShiftApplicationTheWholeSeriesResponse, ShiftApplicationsGet2Data, ShiftApplicationsGet2Response, SettingsGetSettingsData, SettingsGetSettingsResponse, SettingsSetSettingsData, SettingsSetSettingsResponse, SettingsGetSettings2Data, SettingsGetSettings2Response, SettingsSetSettings2Data, SettingsSetSettings2Response, SettingsGetSettingsAllResponse, SettingsValidTimeZoneInfosResponse, RouteSchedulesGetRouteScheduleData, RouteSchedulesGetRouteScheduleResponse, RouteSchedulesDeleteRouteScheduleData, RouteSchedulesDeleteRouteScheduleResponse, RouteSchedulesSaveRouteScheduleData, RouteSchedulesSaveRouteScheduleResponse, RoutesPrioritizeData, RoutesPrioritizeResponse, RoutesPostData, RoutesPostResponse, RoutesGetData, RoutesGetResponse, RoutesPutData, RoutesPutResponse, RoutesDeleteData, RoutesDeleteResponse, RoutesGet2Data, RoutesGet2Response, RecurrentApplicationsGetAllOfPublisherData, RecurrentApplicationsGetAllOfPublisherResponse, RecurrentApplicationsPostData, RecurrentApplicationsPostResponse, RecurrentApplicationsGetSingleData, RecurrentApplicationsGetSingleResponse, RecurrentApplicationsPutData, RecurrentApplicationsPutResponse, RecurrentApplicationsDeleteData, RecurrentApplicationsDeleteResponse, PublishersGetMeResponse, PublishersSearchData, PublishersSearchResponse, PublishersExportResponse, PublishersImportResponse, PublishersImportAllData, PublishersImportAllResponse, PublishersGetProfileData, PublishersGetProfileResponse, PublishersSetProfileData, PublishersSetProfileResponse, PublishersExportVcardResponse, PublishersLockData, PublishersLockResponse, PublishersInviteData, PublishersInviteResponse, PublishersPostData, PublishersPostResponse, PublishersGetData, PublishersGetResponse, PublishersPutData, PublishersPutResponse, PublishersDeleteData, PublishersDeleteResponse, PublishersGet2Data, PublishersGet2Response, PublisherRoutePreferencesGetPreferencesData, PublisherRoutePreferencesGetPreferencesResponse, PublisherRoutePreferencesSetPreferencesData, PublisherRoutePreferencesSetPreferencesResponse, PublisherRoutePreferencesConvertRouteRestrictionToPreferencesData, PublisherRoutePreferencesConvertRouteRestrictionToPreferencesResponse, PlanningSupportPerformPlanningData, PlanningSupportPerformPlanningResponse, PlanningSupportGenerateDraftData, PlanningSupportGenerateDraftResponse, PlanningSupportGetDraftData, PlanningSupportGetDraftResponse, NewsEntriesUploadAttachmentData, NewsEntriesUploadAttachmentResponse, NewsEntriesGetCurrentNewsResponse, NewsEntriesMarkNewsEntryAsReadData, NewsEntriesMarkNewsEntryAsReadResponse, NewsEntriesMarkNewsEntryAsUnreadData, NewsEntriesMarkNewsEntryAsUnreadResponse, NewsEntriesGetNewsStatisticsData, NewsEntriesGetNewsStatisticsResponse, NewsEntriesPostData, NewsEntriesPostResponse, NewsEntriesGetData, NewsEntriesGetResponse, NewsEntriesPutData, NewsEntriesPutResponse, NewsEntriesDeleteData, NewsEntriesDeleteResponse, NewsEntriesGet2Data, NewsEntriesGet2Response, LanguagesGetResponse, InAppNotificationsGetMyUnreadInAppNotificationsResponse, InAppNotificationsGetMyInAppNotificationsResponse, InAppNotificationsMarkAsReadData, InAppNotificationsMarkAsReadResponse, BlobsGetBlobData, BlobsGetBlobResponse, DocumentsGetCircuitReportData, DocumentsGetCircuitReportResponse, FileCabinetListRootResponse, FileCabinetListDirectoryData, FileCabinetListDirectoryResponse, FileCabinetCreateDirectoryData, FileCabinetCreateDirectoryResponse, FileCabinetMoveDirectoryData, FileCabinetMoveDirectoryResponse, FileCabinetRenameDirectoryData, FileCabinetRenameDirectoryResponse, FileCabinetDeleteDirectoryData, FileCabinetDeleteDirectoryResponse, FileCabinetUploadData, FileCabinetUploadResponse, FileCabinetUpdateData, FileCabinetUpdateResponse, FileCabinetDeleteFileData, FileCabinetDeleteFileResponse, FileCabinetMoveFileData, FileCabinetMoveFileResponse, FileCabinetRenameFileData, FileCabinetRenameFileResponse, ShortDocumentUrlGetDocumentData, ShortDocumentUrlGetDocumentResponse, ExternalEventsGetExternalEventsForYearData, ExternalEventsGetExternalEventsForYearResponse, ExternalEventsGetExternalEventsForWeekData, ExternalEventsGetExternalEventsForWeekResponse, ExternalEventsCreateData, ExternalEventsCreateResponse, ExternalEventsDeleteData, ExternalEventsDeleteResponse, ExternalEventCalendarsGetExternalEventCalendarsResponse, ExternalEventCalendarsDeleteExternalEventCalendarData, ExternalEventCalendarsDeleteExternalEventCalendarResponse, ExternalEventCalendarsUploadExternalEventCalendarIcalData, ExternalEventCalendarsUploadExternalEventCalendarIcalResponse, ExperiencesGetAllData, ExperiencesGetAllResponse, ExperiencesCreateExperienceData, ExperiencesCreateExperienceResponse, ExperiencesGetData, ExperiencesGetResponse, ExperiencesSetStateData, ExperiencesSetStateResponse, ExperiencesSetPositiveData, ExperiencesSetPositiveResponse, ExperiencesSetTitleData, ExperiencesSetTitleResponse, ExperiencesGetEventsData, ExperiencesGetEventsResponse, ExperiencesCreateEventData, ExperiencesCreateEventResponse, ExperiencesUpdateEventData, ExperiencesUpdateEventResponse, EmergencyModeCurrentResponse, EmergencyModeEnterEmergencyModeData, EmergencyModeEnterEmergencyModeResponse, EmergencyModeTerminateEmergencyModeResponse, EmergencyModeGetPublisherEmergencyStatusAllResponse, EmergencyModeAcknowledgeData, EmergencyModeAcknowledgeResponse, EmergencyModeReportAsSafeData, EmergencyModeReportAsSafeResponse, EmergencyModeUpdatePublisherEmergencyStatusData, EmergencyModeUpdatePublisherEmergencyStatusResponse, EmergencyModeGetPublisherEmergencyStatusData, EmergencyModeGetPublisherEmergencyStatusResponse, DepotsPostData, DepotsPostResponse, DepotsGetData, DepotsGetResponse, DepotsPutData, DepotsPutResponse, DepotsDeleteData, DepotsDeleteResponse, DepotsGet2Data, DepotsGet2Response, DashboardsGetMyDashboardResponse, DashboardsGetData, DashboardsGetResponse, CutoffDatesGetResponse, CutoffDatesReleaseUntilData, CutoffDatesReleaseUntilResponse, CutoffDatesReleaseUntilDryRunData, CutoffDatesReleaseUntilDryRunResponse, CutoffDatesFinalizeUntilData, CutoffDatesFinalizeUntilResponse, CutoffDatesFinalizeUntilDryRunData, CutoffDatesFinalizeUntilDryRunResponse, CongregationsPostData, CongregationsPostResponse, CongregationsGetData, CongregationsGetResponse, CongregationsPutData, CongregationsPutResponse, CongregationsDeleteData, CongregationsDeleteResponse, CongregationsGet2Data, CongregationsGet2Response, CircuitsPostData, CircuitsPostResponse, CircuitsGetData, CircuitsGetResponse, CircuitsPutData, CircuitsPutResponse, CircuitsDeleteData, CircuitsDeleteResponse, CircuitsGet2Data, CircuitsGet2Response, CalendarsGetMyCalendarUrlResponse, CalendarsCreateCalendarResponse, CalendarsDisableCalendarResponse, AuditGetData, AuditGetResponse, AuditGet2Data, AuditGet2Response, AnalyticsGetMonthReportsResponse, AnalyticsGetMonthReportData, AnalyticsGetMonthReportResponse, AnalyticsGetBranchReportsResponse, AnalyticsGetBranchReportData, AnalyticsGetBranchReportResponse, AnalyticsGetCircuitReportsResponse, AnalyticsGetCircuitReports2Data, AnalyticsGetCircuitReports2Response, AnalyticsProlongCircuitReportAvailabilityData, AnalyticsProlongCircuitReportAvailabilityResponse, AnalyticsGetAssignmentOverviewData, AnalyticsGetAssignmentOverviewResponse, AnalyticsTurnReportsData, AnalyticsTurnReportsResponse, AbsencesGetData, AbsencesGetResponse, AbsencesPostData, AbsencesPostResponse, AbsencesDeleteData, AbsencesDeleteResponse } from './types.gen';

/**
 * @returns void
 * @throws ApiError
 */
export const probesGetHealthzHead = (): CancelablePromise<ProbesGetHealthzHeadResponse> => {
    return __request(OpenAPI, {
        method: 'HEAD',
        url: '/healthz'
    });
};

/**
 * @returns void
 * @throws ApiError
 */
export const probesGetHealthzGet = (): CancelablePromise<ProbesGetHealthzGetResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/healthz'
    });
};

/**
 * @returns binary
 * @throws ApiError
 */
export const snapshotExport = (): CancelablePromise<SnapshotExportResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Snapshot'
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const snapshotImport = (data: SnapshotImportData): CancelablePromise<SnapshotImportResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/Snapshot',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.now
 * @returns string
 * @throws ApiError
 */
export const snapshotOverrideNow = (data: SnapshotOverrideNowData): CancelablePromise<SnapshotOverrideNowResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/Snapshot/clock/now/{now}',
        path: {
            now: data.now
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.period
 * @returns binary
 * @throws ApiError
 */
export const snapshotAdvance = (data: SnapshotAdvanceData): CancelablePromise<SnapshotAdvanceResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/Snapshot/clock/advance/{period}',
        path: {
            period: data.period
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.expand
 * @returns TurnAssignmentCandidateResource
 * @throws ApiError
 */
export const turnsAssignmentCandidates = (data: TurnsAssignmentCandidatesData): CancelablePromise<TurnsAssignmentCandidatesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Turns/{id}/Candidates',
        path: {
            id: data.id
        },
        query: {
            expand: data.expand
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.expand
 * @param data.level
 * @returns TurnPlanningIssueResource
 * @throws ApiError
 */
export const turnsGetIssues = (data: TurnsGetIssuesData): CancelablePromise<TurnsGetIssuesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Turns/{id}/Issues',
        path: {
            id: data.id
        },
        query: {
            expand: data.expand,
            level: data.level
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.expand
 * @param data.filter
 * @param data.sort
 * @param data.page
 * @param data.perPage
 * @returns TurnResource
 * @throws ApiError
 */
export const turnsTurnsOpenForExperiences = (data: TurnsTurnsOpenForExperiencesData = {}): CancelablePromise<TurnsTurnsOpenForExperiencesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Turns/openForExperiences',
        query: {
            expand: data.expand,
            filter: data.filter,
            sort: data.sort,
            page: data.page,
            perPage: data.perPage
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns TurnResource
 * @throws ApiError
 */
export const turnsEnable = (data: TurnsEnableData): CancelablePromise<TurnsEnableResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Turns/{id}/Enabling',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns TurnAssignmentResource
 * @throws ApiError
 */
export const turnsAssign = (data: TurnsAssignData): CancelablePromise<TurnsAssignResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Turns/{id}/Assignment',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns TurnAssignmentResource
 * @throws ApiError
 */
export const turnsRevert = (data: TurnsRevertData): CancelablePromise<TurnsRevertResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Turns/{id}/Revert',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns TurnResource
 * @throws ApiError
 */
export const turnsSetRequiredParticipants = (data: TurnsSetRequiredParticipantsData): CancelablePromise<TurnsSetRequiredParticipantsResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/Turns/{id}/RequiredParticipants',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns TurnResource
 * @throws ApiError
 */
export const turnsCancel = (data: TurnsCancelData): CancelablePromise<TurnsCancelResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Turns/{id}/Cancellation',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.expand
 * @returns TurnLeaderResource
 * @throws ApiError
 */
export const turnsGetOtherTeamLeaders = (data: TurnsGetOtherTeamLeadersData): CancelablePromise<TurnsGetOtherTeamLeadersResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Turns/{id}/OtherTeamLeaders',
        path: {
            id: data.id
        },
        query: {
            expand: data.expand
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.turnId
 * @returns TurnTeamResource
 * @throws ApiError
 */
export const turnsGetPrecedingAndFollowingTeams = (data: TurnsGetPrecedingAndFollowingTeamsData): CancelablePromise<TurnsGetPrecedingAndFollowingTeamsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Turns/{turnId}/PrecedingAndFollowingTeams',
        path: {
            turnId: data.turnId
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.filter
 * @param data.sort
 * @param data.expand
 * @param data.page
 * @param data.perPage
 * @returns binary
 * @throws ApiError
 */
export const turnsGet = (data: TurnsGetData = {}): CancelablePromise<TurnsGetResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Turns',
        query: {
            filter: data.filter,
            sort: data.sort,
            expand: data.expand,
            page: data.page,
            perPage: data.perPage
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.expand
 * @returns binary
 * @throws ApiError
 */
export const turnsGet2 = (data: TurnsGet2Data): CancelablePromise<TurnsGet2Response> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Turns/{id}',
        path: {
            id: data.id
        },
        query: {
            expand: data.expand
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns TurnReportResource
 * @throws ApiError
 */
export const turnReportsCreateTurnReport = (data: TurnReportsCreateTurnReportData): CancelablePromise<TurnReportsCreateTurnReportResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/TurnReports',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.filter
 * @param data.sort
 * @param data.expand
 * @param data.page
 * @param data.perPage
 * @returns binary
 * @throws ApiError
 */
export const turnReportsGet = (data: TurnReportsGetData = {}): CancelablePromise<TurnReportsGetResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/TurnReports',
        query: {
            filter: data.filter,
            sort: data.sort,
            expand: data.expand,
            page: data.page,
            perPage: data.perPage
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.reportId
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const turnReportsPut = (data: TurnReportsPutData): CancelablePromise<TurnReportsPutResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/TurnReports/{reportId}',
        path: {
            reportId: data.reportId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.expand
 * @param data.page
 * @param data.perPage
 * @returns TurnResource
 * @throws ApiError
 */
export const turnReportsGetMissingReports = (data: TurnReportsGetMissingReportsData = {}): CancelablePromise<TurnReportsGetMissingReportsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/TurnReports/TurnsWithoutReport',
        query: {
            expand: data.expand,
            page: data.page,
            perPage: data.perPage
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.expand
 * @returns binary
 * @throws ApiError
 */
export const turnReportsGet2 = (data: TurnReportsGet2Data): CancelablePromise<TurnReportsGet2Response> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/TurnReports/{id}',
        path: {
            id: data.id
        },
        query: {
            expand: data.expand
        }
    });
};

/**
 * @returns NotificationType
 * @throws ApiError
 */
export const subscriptionsGetNotificationTypes = (): CancelablePromise<SubscriptionsGetNotificationTypesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/notification-types'
    });
};

/**
 * @param data The data for the request.
 * @param data.publisherId
 * @returns SubscriptionResource
 * @throws ApiError
 */
export const subscriptionsGetSubscriptions = (data: SubscriptionsGetSubscriptionsData): CancelablePromise<SubscriptionsGetSubscriptionsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/publisher/{publisherId}',
        path: {
            publisherId: data.publisherId
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.publisherId
 * @param data.subscriptions
 * @returns void
 * @throws ApiError
 */
export const subscriptionsUpdateSubscriptions = (data: SubscriptionsUpdateSubscriptionsData): CancelablePromise<SubscriptionsUpdateSubscriptionsResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/publisher/{publisherId}',
        path: {
            publisherId: data.publisherId
        },
        query: {
            subscriptions: data.subscriptions
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.publisherId
 * @param data.notificationTypeId
 * @returns SubscriptionResource
 * @throws ApiError
 */
export const subscriptionsGetSubscription = (data: SubscriptionsGetSubscriptionData): CancelablePromise<SubscriptionsGetSubscriptionResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/publisher/{publisherId}/notification/{notificationTypeId}',
        path: {
            publisherId: data.publisherId,
            notificationTypeId: data.notificationTypeId
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.publisherId
 * @param data.notificationTypeId
 * @param data.canManuallySubscribe
 * @param data.hasSubscribedToInAppNotification
 * @param data.hasSubscribedToSmtpNotification
 * @returns void
 * @throws ApiError
 */
export const subscriptionsUpdateSubscription = (data: SubscriptionsUpdateSubscriptionData): CancelablePromise<SubscriptionsUpdateSubscriptionResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/publisher/{publisherId}/notification',
        path: {
            publisherId: data.publisherId
        },
        query: {
            NotificationTypeId: data.notificationTypeId,
            CanManuallySubscribe: data.canManuallySubscribe,
            HasSubscribedToInAppNotification: data.hasSubscribedToInAppNotification,
            HasSubscribedToSmtpNotification: data.hasSubscribedToSmtpNotification
        }
    });
};

/**
 * @returns ShiftResource
 * @throws ApiError
 */
export const shiftsGetShiftsWithoutTeamLeader = (): CancelablePromise<ShiftsGetShiftsWithoutTeamLeaderResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Shifts/withoutTeamLeader'
    });
};

/**
 * @param data The data for the request.
 * @param data.calendarYear
 * @param data.calendarWeek
 * @param data.expand
 * @returns ShiftResource
 * @throws ApiError
 */
export const shiftsGetShiftsForCalendarWeek = (data: ShiftsGetShiftsForCalendarWeekData): CancelablePromise<ShiftsGetShiftsForCalendarWeekResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Shifts/cw/{calendarYear}/{calendarWeek}',
        path: {
            calendarYear: data.calendarYear,
            calendarWeek: data.calendarWeek
        },
        query: {
            expand: data.expand
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.year
 * @param data.month
 * @param data.day
 * @param data.expand
 * @returns ShiftResource
 * @throws ApiError
 */
export const shiftsGetShiftsForDate = (data: ShiftsGetShiftsForDateData): CancelablePromise<ShiftsGetShiftsForDateResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Shifts/{year}/{month}/{day}',
        path: {
            year: data.year,
            month: data.month,
            day: data.day
        },
        query: {
            expand: data.expand
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.calendarYear
 * @param data.calendarWeek
 * @returns ApplicationEventResource
 * @throws ApiError
 */
export const shiftsGetApplicationEvents = (data: ShiftsGetApplicationEventsData): CancelablePromise<ShiftsGetApplicationEventsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Shifts/ApplicationEvents/{calendarYear}/{calendarWeek}',
        path: {
            calendarYear: data.calendarYear,
            calendarWeek: data.calendarWeek
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns ShiftResource
 * @throws ApiError
 */
export const shiftsReleaseShift = (data: ShiftsReleaseShiftData): CancelablePromise<ShiftsReleaseShiftResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Shifts/{id}/release',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns ShiftResource
 * @throws ApiError
 */
export const shiftsUnreleaseShift = (data: ShiftsUnreleaseShiftData): CancelablePromise<ShiftsUnreleaseShiftResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Shifts/{id}/revocation',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns ShiftResource
 * @throws ApiError
 */
export const shiftsFreezeShift = (data: ShiftsFreezeShiftData): CancelablePromise<ShiftsFreezeShiftResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Shifts/{id}/freeze',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns number
 * @throws ApiError
 */
export const shiftsFreezeShifts = (data: ShiftsFreezeShiftsData): CancelablePromise<ShiftsFreezeShiftsResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Shifts/freeze',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns ShiftResource
 * @throws ApiError
 */
export const shiftsThawShift = (data: ShiftsThawShiftData): CancelablePromise<ShiftsThawShiftResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Shifts/{id}/thawing',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns ShiftResource
 * @throws ApiError
 */
export const shiftsCommitShift = (data: ShiftsCommitShiftData): CancelablePromise<ShiftsCommitShiftResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Shifts/{id}/committal',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.level
 * @param data.expand
 * @returns ShiftVerificationResultResource
 * @throws ApiError
 */
export const shiftsGetIssues = (data: ShiftsGetIssuesData): CancelablePromise<ShiftsGetIssuesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Shifts/{id}/issues',
        path: {
            id: data.id
        },
        query: {
            level: data.level,
            expand: data.expand
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.shiftFilter
 * @param data.level
 * @param data.expand
 * @returns ShiftVerificationResultResource
 * @throws ApiError
 */
export const shiftsGetIssuesAll = (data: ShiftsGetIssuesAllData = {}): CancelablePromise<ShiftsGetIssuesAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Shifts/issues',
        query: {
            shiftFilter: data.shiftFilter,
            level: data.level,
            expand: data.expand
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns ShiftResource
 * @throws ApiError
 */
export const shiftsFinalizeShift = (data: ShiftsFinalizeShiftData): CancelablePromise<ShiftsFinalizeShiftResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Shifts/{id}/finalization',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns ShiftResource
 * @throws ApiError
 */
export const shiftsCancel = (data: ShiftsCancelData): CancelablePromise<ShiftsCancelResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Shifts/{id}/cancellation',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ShiftResource
 * @throws ApiError
 */
export const shiftsScaffold = (data: ShiftsScaffoldData): CancelablePromise<ShiftsScaffoldResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Shifts/scaffold',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns binary
 * @throws ApiError
 */
export const shiftsPost = (data: ShiftsPostData): CancelablePromise<ShiftsPostResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Shifts',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.filter
 * @param data.sort
 * @param data.expand
 * @param data.page
 * @param data.perPage
 * @returns binary
 * @throws ApiError
 */
export const shiftsGet = (data: ShiftsGetData = {}): CancelablePromise<ShiftsGetResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Shifts',
        query: {
            filter: data.filter,
            sort: data.sort,
            expand: data.expand,
            page: data.page,
            perPage: data.perPage
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const shiftsPut = (data: ShiftsPutData): CancelablePromise<ShiftsPutResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/Shifts/{id}',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const shiftsDelete = (data: ShiftsDeleteData): CancelablePromise<ShiftsDeleteResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/Shifts/{id}',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.expand
 * @returns binary
 * @throws ApiError
 */
export const shiftsGet2 = (data: ShiftsGet2Data): CancelablePromise<ShiftsGet2Response> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Shifts/{id}',
        path: {
            id: data.id
        },
        query: {
            expand: data.expand
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ShiftApplicationResource
 * @throws ApiError
 */
export const shiftApplicationsApplyForShift = (data: ShiftApplicationsApplyForShiftData): CancelablePromise<ShiftApplicationsApplyForShiftResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/ShiftApplications',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.filter
 * @param data.sort
 * @param data.expand
 * @param data.page
 * @param data.perPage
 * @returns binary
 * @throws ApiError
 */
export const shiftApplicationsGet = (data: ShiftApplicationsGetData = {}): CancelablePromise<ShiftApplicationsGetResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/ShiftApplications',
        query: {
            filter: data.filter,
            sort: data.sort,
            expand: data.expand,
            page: data.page,
            perPage: data.perPage
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.shiftApplicationId
 * @returns void
 * @throws ApiError
 */
export const shiftApplicationsRevokeShiftApplication = (data: ShiftApplicationsRevokeShiftApplicationData): CancelablePromise<ShiftApplicationsRevokeShiftApplicationResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/ShiftApplications/{shiftApplicationId}',
        path: {
            shiftApplicationId: data.shiftApplicationId
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.shiftApplicationId
 * @returns void
 * @throws ApiError
 */
export const shiftApplicationsRevokeShiftApplicationTheWholeSeries = (data: ShiftApplicationsRevokeShiftApplicationTheWholeSeriesData): CancelablePromise<ShiftApplicationsRevokeShiftApplicationTheWholeSeriesResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/ShiftApplications/series/{shiftApplicationId}',
        path: {
            shiftApplicationId: data.shiftApplicationId
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.expand
 * @returns binary
 * @throws ApiError
 */
export const shiftApplicationsGet2 = (data: ShiftApplicationsGet2Data): CancelablePromise<ShiftApplicationsGet2Response> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/ShiftApplications/{id}',
        path: {
            id: data.id
        },
        query: {
            expand: data.expand
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.categoryKey
 * @returns unknown
 * @throws ApiError
 */
export const settingsGetSettings = (data: SettingsGetSettingsData): CancelablePromise<SettingsGetSettingsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Settings/{categoryKey}',
        path: {
            categoryKey: data.categoryKey
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.categoryKey
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const settingsSetSettings = (data: SettingsSetSettingsData): CancelablePromise<SettingsSetSettingsResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/Settings/{categoryKey}',
        path: {
            categoryKey: data.categoryKey
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.categoryKey
 * @param data.key
 * @returns SettingValueParam
 * @throws ApiError
 */
export const settingsGetSettings2 = (data: SettingsGetSettings2Data): CancelablePromise<SettingsGetSettings2Response> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Settings/{categoryKey}/{key}',
        path: {
            categoryKey: data.categoryKey,
            key: data.key
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.categoryKey
 * @param data.key
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const settingsSetSettings2 = (data: SettingsSetSettings2Data): CancelablePromise<SettingsSetSettings2Response> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/Settings/{categoryKey}/{key}',
        path: {
            categoryKey: data.categoryKey,
            key: data.key
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @returns unknown
 * @throws ApiError
 */
export const settingsGetSettingsAll = (): CancelablePromise<SettingsGetSettingsAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Settings'
    });
};

/**
 * @returns string
 * @throws ApiError
 */
export const settingsValidTimeZoneInfos = (): CancelablePromise<SettingsValidTimeZoneInfosResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Settings/planning/timezones'
    });
};

/**
 * @param data The data for the request.
 * @param data.routeId
 * @returns RouteScheduleResource
 * @throws ApiError
 */
export const routeSchedulesGetRouteSchedule = (data: RouteSchedulesGetRouteScheduleData): CancelablePromise<RouteSchedulesGetRouteScheduleResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/RouteSchedules/{routeId}',
        path: {
            routeId: data.routeId
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.routeId
 * @returns void
 * @throws ApiError
 */
export const routeSchedulesDeleteRouteSchedule = (data: RouteSchedulesDeleteRouteScheduleData): CancelablePromise<RouteSchedulesDeleteRouteScheduleResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/RouteSchedules/{routeId}',
        path: {
            routeId: data.routeId
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const routeSchedulesSaveRouteSchedule = (data: RouteSchedulesSaveRouteScheduleData): CancelablePromise<RouteSchedulesSaveRouteScheduleResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/RouteSchedules',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const routesPrioritize = (data: RoutesPrioritizeData): CancelablePromise<RoutesPrioritizeResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Routes/prioritize',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns binary
 * @throws ApiError
 */
export const routesPost = (data: RoutesPostData): CancelablePromise<RoutesPostResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Routes',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.filter
 * @param data.sort
 * @param data.expand
 * @param data.page
 * @param data.perPage
 * @returns binary
 * @throws ApiError
 */
export const routesGet = (data: RoutesGetData = {}): CancelablePromise<RoutesGetResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Routes',
        query: {
            filter: data.filter,
            sort: data.sort,
            expand: data.expand,
            page: data.page,
            perPage: data.perPage
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const routesPut = (data: RoutesPutData): CancelablePromise<RoutesPutResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/Routes/{id}',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const routesDelete = (data: RoutesDeleteData): CancelablePromise<RoutesDeleteResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/Routes/{id}',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.expand
 * @returns binary
 * @throws ApiError
 */
export const routesGet2 = (data: RoutesGet2Data): CancelablePromise<RoutesGet2Response> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Routes/{id}',
        path: {
            id: data.id
        },
        query: {
            expand: data.expand
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.publisherId
 * @returns RecurrentApplicationResource
 * @throws ApiError
 */
export const recurrentApplicationsGetAllOfPublisher = (data: RecurrentApplicationsGetAllOfPublisherData): CancelablePromise<RecurrentApplicationsGetAllOfPublisherResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/RecurrentApplications/{publisherId}',
        path: {
            publisherId: data.publisherId
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.publisherId
 * @param data.requestBody
 * @returns RecurrentApplicationResource
 * @throws ApiError
 */
export const recurrentApplicationsPost = (data: RecurrentApplicationsPostData): CancelablePromise<RecurrentApplicationsPostResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/RecurrentApplications/{publisherId}',
        path: {
            publisherId: data.publisherId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.publisherId
 * @param data.id
 * @returns RecurrentApplicationResource
 * @throws ApiError
 */
export const recurrentApplicationsGetSingle = (data: RecurrentApplicationsGetSingleData): CancelablePromise<RecurrentApplicationsGetSingleResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/RecurrentApplications/{publisherId}/{id}',
        path: {
            publisherId: data.publisherId,
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.publisherId
 * @param data.id
 * @param data.requestBody
 * @returns RecurrentApplicationResource
 * @throws ApiError
 */
export const recurrentApplicationsPut = (data: RecurrentApplicationsPutData): CancelablePromise<RecurrentApplicationsPutResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/RecurrentApplications/{publisherId}/{id}',
        path: {
            publisherId: data.publisherId,
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.publisherId
 * @param data.applicationId
 * @returns void
 * @throws ApiError
 */
export const recurrentApplicationsDelete = (data: RecurrentApplicationsDeleteData): CancelablePromise<RecurrentApplicationsDeleteResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/RecurrentApplications/{publisherId}/{applicationId}',
        path: {
            publisherId: data.publisherId,
            applicationId: data.applicationId
        }
    });
};

/**
 * @returns PublisherResource
 * @throws ApiError
 */
export const publishersGetMe = (): CancelablePromise<PublishersGetMeResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Publishers/my'
    });
};

/**
 * @param data The data for the request.
 * @param data.q
 * @param data.expand
 * @param data.filter
 * @param data.sort
 * @param data.page
 * @param data.perPage
 * @returns PublisherResource
 * @throws ApiError
 */
export const publishersSearch = (data: PublishersSearchData = {}): CancelablePromise<PublishersSearchResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Publishers/search',
        query: {
            q: data.q,
            expand: data.expand,
            filter: data.filter,
            sort: data.sort,
            page: data.page,
            perPage: data.perPage
        }
    });
};

/**
 * @returns binary
 * @throws ApiError
 */
export const publishersExport = (): CancelablePromise<PublishersExportResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Publishers/export/xlsx'
    });
};

/**
 * @returns binary
 * @throws ApiError
 */
export const publishersImport = (): CancelablePromise<PublishersImportResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Publishers/import/csv'
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns PublisherImportResult
 * @throws ApiError
 */
export const publishersImportAll = (data: PublishersImportAllData): CancelablePromise<PublishersImportAllResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Publishers/import/csv',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns PublisherProfileResource
 * @throws ApiError
 */
export const publishersGetProfile = (data: PublishersGetProfileData): CancelablePromise<PublishersGetProfileResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Publishers/{id}/profile',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns PublisherProfileResource
 * @throws ApiError
 */
export const publishersSetProfile = (data: PublishersSetProfileData): CancelablePromise<PublishersSetProfileResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/Publishers/{id}/profile',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @returns binary
 * @throws ApiError
 */
export const publishersExportVcard = (): CancelablePromise<PublishersExportVcardResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Publishers/export/vcards'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns PublisherResource
 * @throws ApiError
 */
export const publishersLock = (data: PublishersLockData): CancelablePromise<PublishersLockResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Publishers/{id}/lock',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const publishersInvite = (data: PublishersInviteData): CancelablePromise<PublishersInviteResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Publishers/invitation',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns binary
 * @throws ApiError
 */
export const publishersPost = (data: PublishersPostData): CancelablePromise<PublishersPostResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Publishers',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.filter
 * @param data.sort
 * @param data.expand
 * @param data.page
 * @param data.perPage
 * @returns binary
 * @throws ApiError
 */
export const publishersGet = (data: PublishersGetData = {}): CancelablePromise<PublishersGetResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Publishers',
        query: {
            filter: data.filter,
            sort: data.sort,
            expand: data.expand,
            page: data.page,
            perPage: data.perPage
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const publishersPut = (data: PublishersPutData): CancelablePromise<PublishersPutResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/Publishers/{id}',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const publishersDelete = (data: PublishersDeleteData): CancelablePromise<PublishersDeleteResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/Publishers/{id}',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.expand
 * @returns binary
 * @throws ApiError
 */
export const publishersGet2 = (data: PublishersGet2Data): CancelablePromise<PublishersGet2Response> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Publishers/{id}',
        path: {
            id: data.id
        },
        query: {
            expand: data.expand
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.publisherId
 * @returns PublisherRoutePreferenceResource
 * @throws ApiError
 */
export const publisherRoutePreferencesGetPreferences = (data: PublisherRoutePreferencesGetPreferencesData): CancelablePromise<PublisherRoutePreferencesGetPreferencesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/PublisherRoutePreferences/publisher/{publisherId}',
        path: {
            publisherId: data.publisherId
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.publisherId
 * @param data.requestBody
 * @returns PublisherRoutePreferenceResource
 * @throws ApiError
 */
export const publisherRoutePreferencesSetPreferences = (data: PublisherRoutePreferencesSetPreferencesData): CancelablePromise<PublisherRoutePreferencesSetPreferencesResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/PublisherRoutePreferences/publisher/{publisherId}',
        path: {
            publisherId: data.publisherId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const publisherRoutePreferencesConvertRouteRestrictionToPreferences = (data: PublisherRoutePreferencesConvertRouteRestrictionToPreferencesData): CancelablePromise<PublisherRoutePreferencesConvertRouteRestrictionToPreferencesResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/PublisherRoutePreferences/route/{id}/preference-conversion',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const planningSupportPerformPlanning = (data: PlanningSupportPerformPlanningData): CancelablePromise<PlanningSupportPerformPlanningResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/PlanningSupport/plan',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns DownloadLink
 * @throws ApiError
 */
export const planningSupportGenerateDraft = (data: PlanningSupportGenerateDraftData): CancelablePromise<PlanningSupportGenerateDraftResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/PlanningSupport/drafts',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.token
 * @returns binary
 * @throws ApiError
 */
export const planningSupportGetDraft = (data: PlanningSupportGetDraftData): CancelablePromise<PlanningSupportGetDraftResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/PlanningSupport/drafts/{token}',
        path: {
            token: data.token
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.formData
 * @returns NewsEntryAttachmentResource
 * @throws ApiError
 */
export const newsEntriesUploadAttachment = (data: NewsEntriesUploadAttachmentData = {}): CancelablePromise<NewsEntriesUploadAttachmentResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/NewsEntries/Attachments',
        formData: data.formData,
        mediaType: 'multipart/form-data'
    });
};

/**
 * @returns CurrentNewsEntryResource
 * @throws ApiError
 */
export const newsEntriesGetCurrentNews = (): CancelablePromise<NewsEntriesGetCurrentNewsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/NewsEntries/Current'
    });
};

/**
 * @param data The data for the request.
 * @param data.newsEntryId
 * @param data.newsEntryRev
 * @returns void
 * @throws ApiError
 */
export const newsEntriesMarkNewsEntryAsRead = (data: NewsEntriesMarkNewsEntryAsReadData): CancelablePromise<NewsEntriesMarkNewsEntryAsReadResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/NewsEntries/{newsEntryId}/{newsEntryRev}/read',
        path: {
            newsEntryId: data.newsEntryId,
            newsEntryRev: data.newsEntryRev
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.newsEntryId
 * @returns void
 * @throws ApiError
 */
export const newsEntriesMarkNewsEntryAsUnread = (data: NewsEntriesMarkNewsEntryAsUnreadData): CancelablePromise<NewsEntriesMarkNewsEntryAsUnreadResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/NewsEntries/{newsEntryId}/unread',
        path: {
            newsEntryId: data.newsEntryId
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.newsEntryId
 * @returns ReadStatistics
 * @throws ApiError
 */
export const newsEntriesGetNewsStatistics = (data: NewsEntriesGetNewsStatisticsData): CancelablePromise<NewsEntriesGetNewsStatisticsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/NewsEntries/{newsEntryId}/statistics',
        path: {
            newsEntryId: data.newsEntryId
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns binary
 * @throws ApiError
 */
export const newsEntriesPost = (data: NewsEntriesPostData): CancelablePromise<NewsEntriesPostResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/NewsEntries',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.filter
 * @param data.sort
 * @param data.expand
 * @param data.page
 * @param data.perPage
 * @returns binary
 * @throws ApiError
 */
export const newsEntriesGet = (data: NewsEntriesGetData = {}): CancelablePromise<NewsEntriesGetResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/NewsEntries',
        query: {
            filter: data.filter,
            sort: data.sort,
            expand: data.expand,
            page: data.page,
            perPage: data.perPage
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const newsEntriesPut = (data: NewsEntriesPutData): CancelablePromise<NewsEntriesPutResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/NewsEntries/{id}',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const newsEntriesDelete = (data: NewsEntriesDeleteData): CancelablePromise<NewsEntriesDeleteResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/NewsEntries/{id}',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.expand
 * @returns binary
 * @throws ApiError
 */
export const newsEntriesGet2 = (data: NewsEntriesGet2Data): CancelablePromise<NewsEntriesGet2Response> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/NewsEntries/{id}',
        path: {
            id: data.id
        },
        query: {
            expand: data.expand
        }
    });
};

/**
 * @returns string
 * @throws ApiError
 */
export const languagesGet = (): CancelablePromise<LanguagesGetResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Languages'
    });
};

/**
 * @returns InAppNotificationResource
 * @throws ApiError
 */
export const inAppNotificationsGetMyUnreadInAppNotifications = (): CancelablePromise<InAppNotificationsGetMyUnreadInAppNotificationsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/InAppNotifications/my/unread'
    });
};

/**
 * @returns InAppNotificationResource
 * @throws ApiError
 */
export const inAppNotificationsGetMyInAppNotifications = (): CancelablePromise<InAppNotificationsGetMyInAppNotificationsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/InAppNotifications/my'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const inAppNotificationsMarkAsRead = (data: InAppNotificationsMarkAsReadData): CancelablePromise<InAppNotificationsMarkAsReadResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/InAppNotifications/{id}/read-confirmation',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.blobId
 * @param data.disposition
 * @returns binary
 * @throws ApiError
 */
export const blobsGetBlob = (data: BlobsGetBlobData): CancelablePromise<BlobsGetBlobResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Blobs/{blobId}',
        path: {
            blobId: data.blobId
        },
        query: {
            disposition: data.disposition
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.identifier
 * @returns binary
 * @throws ApiError
 */
export const documentsGetCircuitReport = (data: DocumentsGetCircuitReportData): CancelablePromise<DocumentsGetCircuitReportResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Documents/CircuitReports/{identifier}',
        path: {
            identifier: data.identifier
        }
    });
};

/**
 * @returns DirectoryResource
 * @throws ApiError
 */
export const fileCabinetListRoot = (): CancelablePromise<FileCabinetListRootResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/FileCabinet/Directories'
    });
};

/**
 * @param data The data for the request.
 * @param data.directoryId
 * @returns DirectoryResource
 * @throws ApiError
 */
export const fileCabinetListDirectory = (data: FileCabinetListDirectoryData): CancelablePromise<FileCabinetListDirectoryResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/FileCabinet/Directories/{directoryId}',
        path: {
            directoryId: data.directoryId
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.directoryId
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const fileCabinetCreateDirectory = (data: FileCabinetCreateDirectoryData): CancelablePromise<FileCabinetCreateDirectoryResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/FileCabinet/Directories/{directoryId}',
        path: {
            directoryId: data.directoryId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.directoryId
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const fileCabinetMoveDirectory = (data: FileCabinetMoveDirectoryData): CancelablePromise<FileCabinetMoveDirectoryResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/FileCabinet/Directories/{directoryId}/Move',
        path: {
            directoryId: data.directoryId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.directoryId
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const fileCabinetRenameDirectory = (data: FileCabinetRenameDirectoryData): CancelablePromise<FileCabinetRenameDirectoryResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/FileCabinet/Directories/{directoryId}/Rename',
        path: {
            directoryId: data.directoryId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.recursive
 * @returns void
 * @throws ApiError
 */
export const fileCabinetDeleteDirectory = (data: FileCabinetDeleteDirectoryData): CancelablePromise<FileCabinetDeleteDirectoryResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/FileCabinet/Directories/{id}',
        path: {
            id: data.id
        },
        query: {
            recursive: data.recursive
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.directoryId
 * @param data.formData
 * @returns void
 * @throws ApiError
 */
export const fileCabinetUpload = (data: FileCabinetUploadData): CancelablePromise<FileCabinetUploadResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/FileCabinet/Files/{directoryId}',
        path: {
            directoryId: data.directoryId
        },
        formData: data.formData,
        mediaType: 'multipart/form-data'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.formData
 * @returns void
 * @throws ApiError
 */
export const fileCabinetUpdate = (data: FileCabinetUpdateData): CancelablePromise<FileCabinetUpdateResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/FileCabinet/Files/{id}',
        path: {
            id: data.id
        },
        formData: data.formData,
        mediaType: 'multipart/form-data'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const fileCabinetDeleteFile = (data: FileCabinetDeleteFileData): CancelablePromise<FileCabinetDeleteFileResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/FileCabinet/Files/{id}',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.fileId
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const fileCabinetMoveFile = (data: FileCabinetMoveFileData): CancelablePromise<FileCabinetMoveFileResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/FileCabinet/Files/{fileId}/Move',
        path: {
            fileId: data.fileId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.fileId
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const fileCabinetRenameFile = (data: FileCabinetRenameFileData): CancelablePromise<FileCabinetRenameFileResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/FileCabinet/Files/{fileId}/Rename',
        path: {
            fileId: data.fileId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.disposition
 * @returns binary
 * @throws ApiError
 */
export const shortDocumentUrlGetDocument = (data: ShortDocumentUrlGetDocumentData): CancelablePromise<ShortDocumentUrlGetDocumentResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/docs/{id}',
        path: {
            id: data.id
        },
        query: {
            disposition: data.disposition
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.year
 * @returns ExternalEventResource
 * @throws ApiError
 */
export const externalEventsGetExternalEventsForYear = (data: ExternalEventsGetExternalEventsForYearData): CancelablePromise<ExternalEventsGetExternalEventsForYearResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/ExternalEvents/{year}',
        path: {
            year: data.year
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.year
 * @param data.calendarWeek
 * @returns ExternalEventResource
 * @throws ApiError
 */
export const externalEventsGetExternalEventsForWeek = (data: ExternalEventsGetExternalEventsForWeekData): CancelablePromise<ExternalEventsGetExternalEventsForWeekResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/ExternalEvents/{year}/{calendarWeek}',
        path: {
            year: data.year,
            calendarWeek: data.calendarWeek
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ExternalEventResource
 * @throws ApiError
 */
export const externalEventsCreate = (data: ExternalEventsCreateData): CancelablePromise<ExternalEventsCreateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/ExternalEvents',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const externalEventsDelete = (data: ExternalEventsDeleteData): CancelablePromise<ExternalEventsDeleteResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/ExternalEvents/{id}',
        path: {
            id: data.id
        }
    });
};

/**
 * @returns ExternalEventCalendarResource
 * @throws ApiError
 */
export const externalEventCalendarsGetExternalEventCalendars = (): CancelablePromise<ExternalEventCalendarsGetExternalEventCalendarsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/ExternalEventCalendars'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const externalEventCalendarsDeleteExternalEventCalendar = (data: ExternalEventCalendarsDeleteExternalEventCalendarData): CancelablePromise<ExternalEventCalendarsDeleteExternalEventCalendarResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/ExternalEventCalendars/{id}',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.name
 * @param data.formData
 * @returns ExternalEventCalendarResource
 * @throws ApiError
 */
export const externalEventCalendarsUploadExternalEventCalendarIcal = (data: ExternalEventCalendarsUploadExternalEventCalendarIcalData): CancelablePromise<ExternalEventCalendarsUploadExternalEventCalendarIcalResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/ExternalEventCalendars/{name}',
        path: {
            name: data.name
        },
        formData: data.formData,
        mediaType: 'multipart/form-data'
    });
};

/**
 * @param data The data for the request.
 * @param data.expand
 * @param data.sort
 * @param data.filter
 * @param data.page
 * @param data.perPage
 * @returns ExperienceResource
 * @throws ApiError
 */
export const experiencesGetAll = (data: ExperiencesGetAllData = {}): CancelablePromise<ExperiencesGetAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Experiences',
        query: {
            expand: data.expand,
            sort: data.sort,
            filter: data.filter,
            page: data.page,
            perPage: data.perPage
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ExperienceResource
 * @throws ApiError
 */
export const experiencesCreateExperience = (data: ExperiencesCreateExperienceData): CancelablePromise<ExperiencesCreateExperienceResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Experiences',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.expand
 * @returns ExperienceResource
 * @throws ApiError
 */
export const experiencesGet = (data: ExperiencesGetData): CancelablePromise<ExperiencesGetResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Experiences/{id}',
        path: {
            id: data.id
        },
        query: {
            expand: data.expand
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.experienceId
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const experiencesSetState = (data: ExperiencesSetStateData): CancelablePromise<ExperiencesSetStateResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/Experiences/{experienceId}/State',
        path: {
            experienceId: data.experienceId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.experienceId
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const experiencesSetPositive = (data: ExperiencesSetPositiveData): CancelablePromise<ExperiencesSetPositiveResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/Experiences/{experienceId}/IsPositive',
        path: {
            experienceId: data.experienceId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.experienceId
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const experiencesSetTitle = (data: ExperiencesSetTitleData): CancelablePromise<ExperiencesSetTitleResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/Experiences/{experienceId}/Title',
        path: {
            experienceId: data.experienceId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.experienceId
 * @param data.filter
 * @param data.sort
 * @returns ServiceEventResource
 * @throws ApiError
 */
export const experiencesGetEvents = (data: ExperiencesGetEventsData): CancelablePromise<ExperiencesGetEventsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Experiences/{experienceId}/Events',
        path: {
            experienceId: data.experienceId
        },
        query: {
            filter: data.filter,
            sort: data.sort
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.experienceId
 * @param data.requestBody
 * @returns ServiceEventResource
 * @throws ApiError
 */
export const experiencesCreateEvent = (data: ExperiencesCreateEventData): CancelablePromise<ExperiencesCreateEventResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Experiences/{experienceId}/Events',
        path: {
            experienceId: data.experienceId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.experienceId
 * @param data.eventId
 * @param data.requestBody
 * @returns ServiceEventResource
 * @throws ApiError
 */
export const experiencesUpdateEvent = (data: ExperiencesUpdateEventData): CancelablePromise<ExperiencesUpdateEventResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/Experiences/{experienceId}/Events/{eventId}',
        path: {
            experienceId: data.experienceId,
            eventId: data.eventId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @returns EmergencyResource
 * @throws ApiError
 */
export const emergencyModeCurrent = (): CancelablePromise<EmergencyModeCurrentResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/EmergencyMode',
        errors: {
            404: ''
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns EmergencyResource
 * @throws ApiError
 */
export const emergencyModeEnterEmergencyMode = (data: EmergencyModeEnterEmergencyModeData): CancelablePromise<EmergencyModeEnterEmergencyModeResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/EmergencyMode',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @returns void
 * @throws ApiError
 */
export const emergencyModeTerminateEmergencyMode = (): CancelablePromise<EmergencyModeTerminateEmergencyModeResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/EmergencyMode'
    });
};

/**
 * @returns PublisherEmergencyReportResource
 * @throws ApiError
 */
export const emergencyModeGetPublisherEmergencyStatusAll = (): CancelablePromise<EmergencyModeGetPublisherEmergencyStatusAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/EmergencyMode/publisher-emergency-reports'
    });
};

/**
 * @param data The data for the request.
 * @param data.publisherId
 * @returns void
 * @throws ApiError
 */
export const emergencyModeAcknowledge = (data: EmergencyModeAcknowledgeData): CancelablePromise<EmergencyModeAcknowledgeResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/EmergencyMode/publisher-emergency-reports/publisher/{publisherId}/acknowledgement',
        path: {
            publisherId: data.publisherId
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.publisherId
 * @returns void
 * @throws ApiError
 */
export const emergencyModeReportAsSafe = (data: EmergencyModeReportAsSafeData): CancelablePromise<EmergencyModeReportAsSafeResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/EmergencyMode/publisher-emergency-reports/publisher/{publisherId}/safe',
        path: {
            publisherId: data.publisherId
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.publisherId
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const emergencyModeUpdatePublisherEmergencyStatus = (data: EmergencyModeUpdatePublisherEmergencyStatusData): CancelablePromise<EmergencyModeUpdatePublisherEmergencyStatusResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/EmergencyMode/publisher-emergency-reports/publisher/{publisherId}/status',
        path: {
            publisherId: data.publisherId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.publisherId
 * @returns PublisherEmergencyReportResource
 * @throws ApiError
 */
export const emergencyModeGetPublisherEmergencyStatus = (data: EmergencyModeGetPublisherEmergencyStatusData): CancelablePromise<EmergencyModeGetPublisherEmergencyStatusResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/EmergencyMode/publisher-emergency-reports/publisher/{publisherId}',
        path: {
            publisherId: data.publisherId
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns binary
 * @throws ApiError
 */
export const depotsPost = (data: DepotsPostData): CancelablePromise<DepotsPostResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Depots',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.filter
 * @param data.sort
 * @param data.expand
 * @param data.page
 * @param data.perPage
 * @returns binary
 * @throws ApiError
 */
export const depotsGet = (data: DepotsGetData = {}): CancelablePromise<DepotsGetResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Depots',
        query: {
            filter: data.filter,
            sort: data.sort,
            expand: data.expand,
            page: data.page,
            perPage: data.perPage
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const depotsPut = (data: DepotsPutData): CancelablePromise<DepotsPutResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/Depots/{id}',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const depotsDelete = (data: DepotsDeleteData): CancelablePromise<DepotsDeleteResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/Depots/{id}',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.expand
 * @returns binary
 * @throws ApiError
 */
export const depotsGet2 = (data: DepotsGet2Data): CancelablePromise<DepotsGet2Response> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Depots/{id}',
        path: {
            id: data.id
        },
        query: {
            expand: data.expand
        }
    });
};

/**
 * @returns DashboardResource
 * @throws ApiError
 */
export const dashboardsGetMyDashboard = (): CancelablePromise<DashboardsGetMyDashboardResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Dashboards/my'
    });
};

/**
 * @param data The data for the request.
 * @param data.publisherId
 * @returns binary
 * @throws ApiError
 */
export const dashboardsGet = (data: DashboardsGetData): CancelablePromise<DashboardsGetResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Dashboards/{publisherId}',
        path: {
            publisherId: data.publisherId
        }
    });
};

/**
 * @returns CutoffDatesResource
 * @throws ApiError
 */
export const cutoffDatesGet = (): CancelablePromise<CutoffDatesGetResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/CutoffDates'
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CutoffDatesResource
 * @throws ApiError
 */
export const cutoffDatesReleaseUntil = (data: CutoffDatesReleaseUntilData): CancelablePromise<CutoffDatesReleaseUntilResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/CutoffDates/release',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @param data.expand
 * @returns FinalizeResponse
 * @throws ApiError
 */
export const cutoffDatesReleaseUntilDryRun = (data: CutoffDatesReleaseUntilDryRunData): CancelablePromise<CutoffDatesReleaseUntilDryRunResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/CutoffDates/release/dryRun',
        query: {
            expand: data.expand
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CutoffDatesResource
 * @throws ApiError
 */
export const cutoffDatesFinalizeUntil = (data: CutoffDatesFinalizeUntilData): CancelablePromise<CutoffDatesFinalizeUntilResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/CutoffDates/finalization',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns FinalizeResponse
 * @throws ApiError
 */
export const cutoffDatesFinalizeUntilDryRun = (data: CutoffDatesFinalizeUntilDryRunData): CancelablePromise<CutoffDatesFinalizeUntilDryRunResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/CutoffDates/finalization/dryRun',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns binary
 * @throws ApiError
 */
export const congregationsPost = (data: CongregationsPostData): CancelablePromise<CongregationsPostResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Congregations',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.filter
 * @param data.sort
 * @param data.expand
 * @param data.page
 * @param data.perPage
 * @returns binary
 * @throws ApiError
 */
export const congregationsGet = (data: CongregationsGetData = {}): CancelablePromise<CongregationsGetResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Congregations',
        query: {
            filter: data.filter,
            sort: data.sort,
            expand: data.expand,
            page: data.page,
            perPage: data.perPage
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const congregationsPut = (data: CongregationsPutData): CancelablePromise<CongregationsPutResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/Congregations/{id}',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const congregationsDelete = (data: CongregationsDeleteData): CancelablePromise<CongregationsDeleteResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/Congregations/{id}',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.expand
 * @returns binary
 * @throws ApiError
 */
export const congregationsGet2 = (data: CongregationsGet2Data): CancelablePromise<CongregationsGet2Response> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Congregations/{id}',
        path: {
            id: data.id
        },
        query: {
            expand: data.expand
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns binary
 * @throws ApiError
 */
export const circuitsPost = (data: CircuitsPostData): CancelablePromise<CircuitsPostResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Circuits',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.filter
 * @param data.sort
 * @param data.expand
 * @param data.page
 * @param data.perPage
 * @returns binary
 * @throws ApiError
 */
export const circuitsGet = (data: CircuitsGetData = {}): CancelablePromise<CircuitsGetResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Circuits',
        query: {
            filter: data.filter,
            sort: data.sort,
            expand: data.expand,
            page: data.page,
            perPage: data.perPage
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const circuitsPut = (data: CircuitsPutData): CancelablePromise<CircuitsPutResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/Circuits/{id}',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const circuitsDelete = (data: CircuitsDeleteData): CancelablePromise<CircuitsDeleteResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/Circuits/{id}',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.expand
 * @returns binary
 * @throws ApiError
 */
export const circuitsGet2 = (data: CircuitsGet2Data): CancelablePromise<CircuitsGet2Response> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Circuits/{id}',
        path: {
            id: data.id
        },
        query: {
            expand: data.expand
        }
    });
};

/**
 * @returns CalendarUrl
 * @throws ApiError
 */
export const calendarsGetMyCalendarUrl = (): CancelablePromise<CalendarsGetMyCalendarUrlResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Calendars/my/url'
    });
};

/**
 * @returns CalendarUrl
 * @throws ApiError
 */
export const calendarsCreateCalendar = (): CancelablePromise<CalendarsCreateCalendarResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Calendars/my'
    });
};

/**
 * @returns void
 * @throws ApiError
 */
export const calendarsDisableCalendar = (): CancelablePromise<CalendarsDisableCalendarResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/Calendars/my'
    });
};

/**
 * @param data The data for the request.
 * @param data.filter
 * @param data.sort
 * @param data.expand
 * @param data.page
 * @param data.perPage
 * @returns binary
 * @throws ApiError
 */
export const auditGet = (data: AuditGetData = {}): CancelablePromise<AuditGetResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Audit',
        query: {
            filter: data.filter,
            sort: data.sort,
            expand: data.expand,
            page: data.page,
            perPage: data.perPage
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.expand
 * @returns binary
 * @throws ApiError
 */
export const auditGet2 = (data: AuditGet2Data): CancelablePromise<AuditGet2Response> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Audit/{id}',
        path: {
            id: data.id
        },
        query: {
            expand: data.expand
        }
    });
};

/**
 * @returns MonthResource
 * @throws ApiError
 */
export const analyticsGetMonthReports = (): CancelablePromise<AnalyticsGetMonthReportsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Analytics/MonthReports'
    });
};

/**
 * @param data The data for the request.
 * @param data.year
 * @param data.month
 * @returns MonthReportResource
 * @throws ApiError
 */
export const analyticsGetMonthReport = (data: AnalyticsGetMonthReportData): CancelablePromise<AnalyticsGetMonthReportResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Analytics/MonthReport/{year}/{month}',
        path: {
            year: data.year,
            month: data.month
        }
    });
};

/**
 * @returns MonthResource
 * @throws ApiError
 */
export const analyticsGetBranchReports = (): CancelablePromise<AnalyticsGetBranchReportsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Analytics/BranchReports'
    });
};

/**
 * @param data The data for the request.
 * @param data.year
 * @param data.month
 * @returns BranchReportResource
 * @throws ApiError
 */
export const analyticsGetBranchReport = (data: AnalyticsGetBranchReportData): CancelablePromise<AnalyticsGetBranchReportResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Analytics/BranchReports/{year}/{month}',
        path: {
            year: data.year,
            month: data.month
        }
    });
};

/**
 * @returns QuarterResource
 * @throws ApiError
 */
export const analyticsGetCircuitReports = (): CancelablePromise<AnalyticsGetCircuitReportsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Analytics/CircuitReports'
    });
};

/**
 * @param data The data for the request.
 * @param data.year
 * @param data.quarter
 * @returns CircuitReportResource
 * @throws ApiError
 */
export const analyticsGetCircuitReports2 = (data: AnalyticsGetCircuitReports2Data): CancelablePromise<AnalyticsGetCircuitReports2Response> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Analytics/CircuitReports/{year}/{quarter}',
        path: {
            year: data.year,
            quarter: data.quarter
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.year
 * @param data.quarter
 * @param data.circuitId
 * @returns DownloadLink2
 * @throws ApiError
 */
export const analyticsProlongCircuitReportAvailability = (data: AnalyticsProlongCircuitReportAvailabilityData): CancelablePromise<AnalyticsProlongCircuitReportAvailabilityResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Analytics/CircuitReports/{year}/{quarter}/{circuitId}/prolong',
        path: {
            year: data.year,
            quarter: data.quarter,
            circuitId: data.circuitId
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.year
 * @param data.week
 * @param data.disposition
 * @param data.includeInvisible
 * @returns string
 * @throws ApiError
 */
export const analyticsGetAssignmentOverview = (data: AnalyticsGetAssignmentOverviewData): CancelablePromise<AnalyticsGetAssignmentOverviewResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Analytics/assignmentOverview/{year}/{week}',
        path: {
            year: data.year,
            week: data.week
        },
        query: {
            disposition: data.disposition,
            includeInvisible: data.includeInvisible
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.year
 * @param data.month
 * @param data.disposition
 * @returns string
 * @throws ApiError
 */
export const analyticsTurnReports = (data: AnalyticsTurnReportsData): CancelablePromise<AnalyticsTurnReportsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Analytics/turnReports/{year}/{month}',
        path: {
            year: data.year,
            month: data.month
        },
        query: {
            disposition: data.disposition
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.publisherId
 * @returns AbsenceResource
 * @throws ApiError
 */
export const absencesGet = (data: AbsencesGetData): CancelablePromise<AbsencesGetResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/Absences/{publisherId}',
        path: {
            publisherId: data.publisherId
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.publisherId
 * @param data.requestBody
 * @returns AbsenceResource
 * @throws ApiError
 */
export const absencesPost = (data: AbsencesPostData): CancelablePromise<AbsencesPostResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/Absences/{publisherId}',
        path: {
            publisherId: data.publisherId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.publisherId
 * @param data.absenceId
 * @returns void
 * @throws ApiError
 */
export const absencesDelete = (data: AbsencesDeleteData): CancelablePromise<AbsencesDeleteResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/Absences/{publisherId}/{absenceId}',
        path: {
            publisherId: data.publisherId,
            absenceId: data.absenceId
        }
    });
};